module.exports = __webpack_public_path__ + "img/twitter-circle-48px.32be5b4.svg";